import { showHttpErrorAlertCallout } from "@/shared/utils/show-http-error-alert-callout";
import { getCompanyGroupById } from "@/spz-api/company-groups/company-groups";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useCompanyGroupForm } from "../hooks/use-company-group-form";
import type { CompanyGroupFormSchemaValues } from "./schemas/company-group-form.schema";

export const selectCompanyGroupFormViewModel = ({
  groupId,
  onSuccess,
}: {
  groupId?: string;
  onSuccess?: () => void;
}) => {
  const { t } = useTranslation();
  const companyGroupForm = useCompanyGroupForm({
    groupId,
    onSuccess,
  });

  useEffect(() => {
    if (!groupId) {
      return;
    }

    // Query company group information
    getCompanyGroupById(groupId)
      .then((response) => {
        const companyGroup = response.data;

        const initialValues: CompanyGroupFormSchemaValues = {
          name: companyGroup.name,
          description: companyGroup.description ?? undefined,
          companies: companyGroup.companyIds,
          updatedAt: companyGroup.updatedAt,
        };
        companyGroupForm.form.reset(initialValues);
      })
      .catch((error) => {
        showHttpErrorAlertCallout({
          error,
          defaultErrorMessage: t("group_fetch_by_id_error"),
        });
      });
  }, [t, groupId, companyGroupForm.form.reset]);

  return {
    form: companyGroupForm.form,
    onSubmit: companyGroupForm.onSubmit,
    companies: companyGroupForm.companies,
  };
};
